import affectedBundles from './slice.affectedBundles'
import auth from './slice.auth'
import integrations from './slice.integrations'

export default {
  auth,
  affectedBundles,
  integrations
}
